import { Box, Menu, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../../api/hooks/useColors";
import { LogicNameFilter } from "../../utils/constants";
import FilterTrigger from "./FilterTrigger";
import OptionList from "./OptionList";
import SearchField from "./SearchField";
import SwitchButton from "./SwitchButton";

export default function FilterMenu({
  filterName,
  fieldName,
  // An option called "All" acts as a select all option
  options,
  appliedFilters,
  setAppliedFilters,
  showSearch = false,
  logicControl = false,
  timeControl = false,
  setFilterLogic = null,
  displayAs = "chip",
  icon = null,
  singleSelect = false,
  filterLogic = LogicNameFilter.LOGIC_AND,
  ...props
}) {
  const colors = useColors();
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState(options);
  const [logic, setLogic] = useState(filterLogic);
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    setLogic(filterLogic);
  }, [filterLogic]);

  useEffect(() => {
    if (appliedFilters[fieldName]) {
      const selected = [];
      Object.keys(appliedFilters[fieldName]).forEach((key) => {
        if (appliedFilters[fieldName][key]) {
          selected.push(key);
        }
      });
      const selectedName = options
        .filter((opt) => selected.includes(opt.name) && opt.name !== "All")
        .map((opt) => opt.displayName);
      setSelectedOptions(selectedName);
    }
  }, [appliedFilters, fieldName]);

  useEffect(() => {
    setSearchResults(
      searchQuery
        ? options.filter((opt) => {
            const labelToSearch = opt.displayName + opt.name;
            if (opt.name === "All") return false;
            return labelToSearch
              .toLowerCase()
              .includes(searchQuery.toLowerCase());
          })
        : options
    );
  }, [searchQuery, options]);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const handleLogicChange = (event) => {
    const newLogic = event;
    setLogic(newLogic);
    if (setFilterLogic) {
      setFilterLogic((prv) => ({ ...prv, [fieldName]: newLogic }));
    }
  };
  return (
    <Box>
      <FilterTrigger
        displayAs={displayAs}
        filterName={filterName}
        selectedOption={selectedOptions}
        options={options}
        onClick={handleOpen}
        onDelete={() => {
          setAppliedFilters((prev) => ({ ...prev, [fieldName]: {} }));
        }}
        icon={icon}
        colors={colors}
        filterLogic={logic}
        setFilterLogic={setFilterLogic}
        {...props}
      />
      <Menu
        anchorEl={anchorEl}
        key={"simple-menu" + filterName}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        sx={{
          color: colors.contrast_text_dark,
          "& .MuiPaper-root": {
            borderRadius: "8px",
            minWidth: "150px",
            border: "1px solid " + colors.divider2,
            boxShadow: "0px 1px 4px 0px " + colors.black_10percent,
          },
          "& .MuiList-root": {
            padding: "8px",
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          },
        }}
      >
        {logicControl && (
          <SwitchButton
            selectedLogic={logic}
            onChange={handleLogicChange}
            logicsAndLabels={{
              [LogicNameFilter.LOGIC_AND]: "All Conditions",
              [LogicNameFilter.LOGIC_OR]: "Any Condition",
            }}
          />
        )}
        {timeControl && (
          <SwitchButton
            selectedLogic={logic}
            onChange={handleLogicChange}
            logicsAndLabels={{
              [LogicNameFilter.TIME_AFTER]: "In the last",
              [LogicNameFilter.TIME_BEFORE]: "Before the last",
            }}
          />
        )}
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          {showSearch && options?.length > 4 && (
            <SearchField
              searchQuery={searchQuery}
              setSearchQuery={setSearchQuery}
              colors={colors}
              theme={theme}
            />
          )}

          <OptionList
            options={searchResults}
            appliedFilters={appliedFilters}
            setAppliedFilters={setAppliedFilters}
            fieldName={fieldName}
            singleSelect={singleSelect}
          />
        </Box>
      </Menu>
    </Box>
  );
}
